import { render, staticRenderFns } from "./touchDetail1.vue?vue&type=template&id=05e58b04&scoped=true&"
import script from "./touchDetail1.vue?vue&type=script&lang=js&"
export * from "./touchDetail1.vue?vue&type=script&lang=js&"
import style0 from "./touchDetail1.vue?vue&type=style&index=0&id=05e58b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e58b04",
  null
  
)

export default component.exports